


























const colorMap: any = {
  'reddish-orange': '#fa6123',
  'algae-green': '#21b963',
  'dodger-blue': '#3294f1',
  'light-orange': '#faa33e',
  'bluey-purple': '#5d40c6',
  'darkish-pink': '#e14f9d',
  'dark-teal': '#01363d',
  'bluish-grey': '#778c90',
  'light-grey-three': '#e7e4df',
  'off-white': '#faf9f6',
  kabul: '#604c3f',
  strawberry: '#ff2629',
  viridian: '#198c62',
  slate: '#3f5b60',
}

import Vue from 'vue'

/**
 * DdTag component is based on ElTag to display a tag.
 */

export default Vue.extend({
  name: 'DdTag',

  props: {
    /**
     * Tag description text - for tag input
     */
    text: {
      type: String,
      default: '',
    },
    /**
     * Boolean indicating if DdTag is selected
     */
    isSelected: {
      type: Boolean,
      default: false,
    },
    /**
     * Type of tag: filled, outline, input, label
     */
    type: {
      type: String,
      default: 'input',
    },
    /**
     * Color of tag
     */
    color: {
      type: String,
      default: 'info',
    },

    /**
     * Determines if remove icon should or not be rendered
     */
    closable: {
      type: Boolean,
      default: true,
    },

    /**
     * Determines if tag has border radius
     */
    hasBorderRadius: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tagSize(): String {
      if (this.type === 'label') {
        return 'small'
      } else if (this.type === 'input') {
        return 'medium'
      } else {
        return 'mini'
      }
    },
    styleClass(): Object {
      if (this.type === 'filled') {
        return this.filledClass
      } else if (this.type === 'outline') {
        return this.outlineClass
      } else {
        return {}
      }
    },
    outlineClass(): Object {
      return {
        padding: '3px 6px',
        lineHeight: 1,
        color:
          this.color !== 'info'
            ? colorMap[this.color]
            : colorMap['bluish-grey'],
        textTransform: 'uppercase',
        backgroundColor: '#fff',
        border: `1px solid #dfe4e5`,
      }
    },
    filledClass(): Object {
      return {
        padding: '0 8px',
        lineHeight: '18px',
        color: '#fff',
        backgroundColor:
          this.color !== 'info'
            ? colorMap[this.color]
            : colorMap['bluish-grey'],
      }
    },
  },

  methods: {
    closeTag(e: any) {
      this.$emit('close', e)
    },
  },
})
